import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { contactsColorKeys } from './_colors'

const ContactSourceColors = contactsColorKeys.Contacts.ContactSource

const ContactSourceParts = [
  'container',
  'labelText',
  'dataContainer',
  'iconContainer',
  'icon',
  'nameText',
  'pmsText',
] as const

const helpers = createMultiStyleConfigHelpers(ContactSourceParts)

export const ContactSourceStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      paddingY: '1.25rem',
      gap: '0.5rem',
    },
    labelText: {
      textStyle: textStyleKeys.Body1,
    },
    dataContainer: {
      gap: '0.5rem',
      alignItems: 'center',
    },
    iconContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      boxSize: '2.25rem',
      borderRadius: '0.5rem',
      border: '1px solid',
      borderColor: ContactSourceColors.IconContainer.BorderColor,
      gap: '0.5rem',
    },
    icon: {
      boxSize: '1.5rem',
    },
    nameText: {
      textStyle: textStyleKeys.Body1,
    },
    pmsText: {
      textStyle: textStyleKeys.Body1,
    },
  },
})

export const useContactSourceStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof ContactSourceParts>(
    getName({ ContactSourceStyle }),
    props,
  )
}
